module.exports = __webpack_public_path__ + "public/images/npr@2x.a7335b13473187a0e4dfc0500f0a063c.png";